import { OFFER_CONFIG } from "@constants";
import { getEndpoint } from "./endpoint";

const MS_NAME = "mnp-facade";

export const GET_PORT_IN_SLOT_ROUTE = `${getEndpoint(MS_NAME)}ref-port-days/${OFFER_CONFIG.BRAND}/${
    OFFER_CONFIG.CHANNEL
}`;

export const validateMobileNumberPortRoute = (phoneNumber: string) =>
    `${getEndpoint(MS_NAME)}ref-networks/${phoneNumber}/operator`;
